import history from '../history';
import { createRouterReducer } from '../lib/redux-router';

export default createRouterReducer(history);
